import { SuperAdminConstants } from '../../../_constants';

const initialState = { combinedMetricAllowLoading: true, data: '', error: false };

export function combinedMetricAllowReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_COMBINED_ALLOW_METRIC:
            return {
                combinedMetricAllowLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_COMBINED_ALLOW_METRIC:
            return {
                combinedMetricAllowLoading: false,
                data: action,
                error: false
            };
        case SuperAdminConstants.COMBINED_ALLOW_METRIC_ERROR:
            return {
                combinedMetricAllowLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/DefineMetric/combinedMetricAllow.reducer.js